import React, { Component } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { connect } from "react-redux";

// Import Routes
import { authProtectedRoutes, publicRoutes } from "./routes";

// layouts
import HorizontalLayout from "./components/HorizontalLayout/";
import NonAuthLayout from "./components/NonAuthLayout";



// Import scss
import "./assets/scss/theme.scss";

import AppRoute from "./routes/route";
import StaffLayout from "./components/StaffLayout";

class App extends Component {
	constructor(props) {
		super(props);
		this.state = {};
		this.getLayout = this.getLayout.bind(this);
	}

	

	getLayout = () => {
		const user = JSON.parse(localStorage.getItem("user") || "{}");
		const userRoles = user?.type ? user.type.split(",") : [];

		
		if (userRoles.includes("staff")) {
			return StaffLayout;
		}
		if (userRoles.includes("admin")) {
			return HorizontalLayout; 
		}

		return HorizontalLayout;
	};

	render() {
		const Layout = this.getLayout();

		// Get user from localStorage (fallback to an empty object if null)
		const user = JSON.parse(localStorage.getItem("user") || "{}");
		const userRoles = user?.type ? user.type.split(",") : [];

		const getDashboardRedirect = () => {
			if (userRoles.includes("admin")) return "/admin/dashboard";
			if (userRoles.includes("staff")) return "/staff/dashboard";
			return "/"; // Default if no roles or not logged in
		};

		return (
			<React.Fragment>
				<Routes>
					{/* 🔹 Wrap Root Redirect Inside Layout */}
					<Route
						path="/"
						element={
							userRoles.length > 0 ? (
								<AppRoute allowedRoles={userRoles}>
									<Layout>
										<Navigate to={getDashboardRedirect()} />
									</Layout>
								</AppRoute>
							) : (
								<Navigate to="/login" />
							)
						}
					/>

					{/* Public Routes (No authentication required) */}
					{publicRoutes.map((route, idx) => (
						<Route
							key={idx}
							path={route.path}
							element={<NonAuthLayout>{route.component}</NonAuthLayout>}
						/>
					))}

					{/* Protected  fd Route (Require authentication and role check) */}
					{authProtectedRoutes.map((route, idx) => (
						<Route
							key={idx}
							path={route.path}
							element={
								<AppRoute allowedRoles={route.allowedRoles}>
									<Layout>{route.component}</Layout>
								</AppRoute>
							}
						/>
					))}
				</Routes>
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		layout: state.Layout,
	};
};

export default connect(mapStateToProps, null)(App);